import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PaymentFlowStateService } from '../services/payment-flow-state.service';

export const finalPageGuard: CanActivateFn = () => {
  const router = inject(Router);
  const flowState = inject(PaymentFlowStateService);

  if (flowState.consumeFinalPageAccess()) {
    return true;
  }

  return router.createUrlTree(['/error']);
};
